/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：997
 */

var r = require(/* 728 */"../../../../1177/728/index")(Object, "create")
module.exports = r
